import type { ITableConsumerState } from './ITableConsumerState';

export type TableColumnType =
    | 'string'
    | 'number'
    | 'date'
    | 'amount'
    | 'dateTime'
    | 'boolean'
    | 'yearMonthDay';
export type TableColumnValue = string | number | Date | boolean | Array<string>;
export type TableColumnAlign = 'left' | 'center' | 'right';

export interface ITableColumnDef<DataType = any, FilterType = any> {
    translation: string;
    key: string;
    type?: TableColumnType;
    align?: TableColumnAlign;
    sortable?: boolean;
    render?: (
        value: TableColumnValue,
        column: TableColumnDef<DataType, FilterType>,
        context: ITableConsumerState<DataType, FilterType>,
        row: DataType,
    ) => JSX.Element;
    export?: boolean | string | Array<string>;
}

export class TableColumnDef<
    DataType = any,
    FilterType = any,
> implements ITableColumnDef<DataType, FilterType> {
    public translation: string;
    public key: string;
    public type?: TableColumnType = 'string';
    align?: TableColumnAlign = 'center';
    sortable?: boolean = false;
    render?: (
        value: TableColumnValue,
        column: TableColumnDef<DataType, FilterType>,
        context: ITableConsumerState<DataType, FilterType>,
        row: DataType,
    ) => JSX.Element;
    export?: boolean | string | Array<string>;

    constructor(params: ITableColumnDef<DataType, FilterType>) {
        Object.assign(this, params);
    }
}
